module.exports = __webpack_public_path__ + "img/upload.694926c6.svg";